
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'InvestmentSectionLoader',
  components: { SkeletonLoader }
})
export default class InvestmentSectionLoader extends Vue {}
